import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import moment from 'moment';
import {getValueHash,getValueArray} from '../../../common/utils/array';


import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Typography from '@material-ui/core/Typography';

import Aggregates from './aggregate-item';
import Conditions from './condition-item';

import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import {DatePicker} from "material-ui-pickers";
import Checkbox from '@material-ui/core/Checkbox';
import Divider from '@material-ui/core/Divider';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';




const styles = theme => ({
	root: {
		width: '100%',
	},
	heading: {
		fontSize: theme.typography.pxToRem(15),
	},
	secondaryHeading: {
		fontSize: theme.typography.pxToRem(13),
		color: theme.palette.text.secondary,
	},
	icon: {
		verticalAlign: 'bottom',
		height: 20,
		width: 20,
	},
	details: {
		display:'block',
		paddingTop:15
	},
	summary:{
		backgroundColor:'rgba(244, 236, 225, 0.5)'
	},
	summaryColumnLeft: {
		flexBasis: '20%',
	},
	summaryColumnRight: {
		flexBasis: '80%',
	},
	datePicker : {
		marginTop : '-7px',
		width:'150px'
	},
	dateLabel:{
		paddingRight:15,
		paddingTop:12,
		boxSizing:'border-box'

	},
	fromTo : {
		padding: '0 15px',
		fontSize: '1.5rem',
		fontFamily: "Roboto, Helvetica, Arial, sans-serif",
	},

});

const dateDiffMax = 180;


class innerForm extends React.Component {

	constructor(props) {
		super(props);

		let dateType = "0";
		let selectedDateFrom = null;
		let selectedDateTo = null;
		if("conditionDate" in props.dataSource){
			if("dateType" in props.dataSource.conditionDate && (props.dataSource.conditionDate.dateType)){
				dateType = props.dataSource.conditionDate.dateType;
			}
			if("from" in props.dataSource.conditionDate && (props.dataSource.conditionDate.from !== null)){
				const fromDate = new Date(props.dataSource.conditionDate.from);
				selectedDateFrom = moment(fromDate.toISOString());
			}
			if("to" in props.dataSource.conditionDate && (props.dataSource.conditionDate.to !== null)){
				const toDate = new Date(props.dataSource.conditionDate.to);
				selectedDateTo = moment(toDate.toISOString());
			}
		}

		this.state = {
			dataSource : props.dataSource,
			aggregateSource : props.aggregateSource,
			conditionSource : props.conditionSource,
			dateType : dateType,
			selectedDateFrom : selectedDateFrom,
			selectedDateTo : selectedDateTo
		}
	}

	UNSAFE_componentWillReceiveProps(nextProps){
		if(this.state.dataSource !== nextProps.dataSource){
			const dataSource = getValueHash(nextProps.dataSource);
			let dateType = "0";
			let selectedDateFrom = null;
			let selectedDateTo = null;
			if("conditionDate" in dataSource){
				if("dateType" in dataSource.conditionDate && (dataSource.conditionDate.dateType)){
					dateType = dataSource.conditionDate.dateType;
				}
				if("from" in dataSource.conditionDate && (dataSource.conditionDate.from !== null)){
					const fromDate = new Date(dataSource.conditionDate.from);
					selectedDateFrom = moment(fromDate.toISOString());
				}
				if("to" in dataSource.conditionDate && (dataSource.conditionDate.to !== null)){
					const toDate = new Date(dataSource.conditionDate.to);
					selectedDateTo = moment(toDate.toISOString());
				}
			}

			this.setState({
				dataSource,
				dateType,
				selectedDateFrom,
				selectedDateTo
			});


		}
	}

	handleDateTypeChange = event => {
		this.setState({ dateType: event.target.value });
		let dataSource = getValueHash(this.state.dataSource);
		let conditionDate = getValueHash(dataSource.conditionDate);
		conditionDate.dateType = event.target.value;

		dataSource.conditionDate = conditionDate;
		if(this.props.afterChangeFunction) this.props.afterChangeFunction(dataSource);
	};

	handleDateFromChange = date => {
		let selectedDateTo = this.state.selectedDateTo;
		if(selectedDateTo !== null){
			const dateDiff = selectedDateTo.diff(date,'days');
			if(dateDiff < 0) {
				selectedDateTo = new moment(date);
			}
			else if(dateDiff > dateDiffMax){
				selectedDateTo = new moment(date);
				selectedDateTo.add(dateDiffMax,'days');
			}
		}
		this.setState({
			selectedDateFrom: date,
			selectedDateTo
		});
		let dataSource = getValueHash(this.state.dataSource);
		let conditionDate = getValueHash(dataSource.conditionDate);
		conditionDate.from = new moment(date).format('YYYY/MM/DD');
		conditionDate.to = !(selectedDateTo) ? null : new moment(selectedDateTo).format('YYYY/MM/DD');
		dataSource.conditionDate = conditionDate;

		if(this.props.afterChangeFunction) this.props.afterChangeFunction(dataSource);
	};
	handleDateFromInputChange = (e) =>{
		if(!e.target.value){
			this.setState({ selectedDateFrom: null });

			let dataSource = getValueHash(this.state.dataSource);
			let conditionDate = getValueHash(dataSource.conditionDate);
			conditionDate.from = null;
			dataSource.conditionDate = conditionDate;
			if(this.props.afterChangeFunction) this.props.afterChangeFunction(dataSource);
		}
	};
	handleDateToChange = date => {
		let selectedDateFrom = this.state.selectedDateFrom;
		if(selectedDateFrom !== null){
			const dateDiff = date.diff(selectedDateFrom,'days');
			if(dateDiff < 0) {
				selectedDateFrom = new moment(date);
			}
			else if(dateDiff > dateDiffMax){
				selectedDateFrom = new moment(date);
				selectedDateFrom.add(dateDiffMax * -1,'days');
			}
		}
		this.setState({
			selectedDateFrom,
			selectedDateTo: date
		});

		let dataSource = getValueHash(this.state.dataSource);
		let conditionDate = getValueHash(dataSource.conditionDate);
		conditionDate.from = !(selectedDateFrom) ? null : new moment(selectedDateFrom).format('YYYY/MM/DD');
		conditionDate.to = new moment(date).format('YYYY/MM/DD');
		dataSource.conditionDate = conditionDate;

		if(this.props.afterChangeFunction) this.props.afterChangeFunction(dataSource);


	};
	handleDateToInputChange = (e) =>{
		if(!e.target.value){
			this.setState({ selectedDateTo: null });

			let dataSource = getValueHash(this.state.dataSource);
			let conditionDate = getValueHash(dataSource.conditionDate);
			conditionDate.to = null;
			dataSource.conditionDate = conditionDate;
			if(this.props.afterChangeFunction) this.props.afterChangeFunction(dataSource);
		}

	};

	handleAggregateItemChange = (index,category,value) =>{
		let dataSource = getValueHash(this.state.dataSource);
		let aggregates = getValueHash(dataSource.aggregates);
		let currentAggregates = aggregates[index];
		if(!currentAggregates){
			currentAggregates = {value:value,order:"ASC"};
			aggregates[index] = currentAggregates;
		}
		else{
			if(category === "value"){
				if(!value){
					aggregates.splice(index,aggregates.length-index);
				}
				else{
					currentAggregates = {value:value,order:currentAggregates.order};
					aggregates[index] = currentAggregates;
				}
			}
			else{
				currentAggregates = {value:currentAggregates.value,order:value};
				aggregates[index] = currentAggregates;
			}
		}

		dataSource.aggregates = aggregates;

		if(this.props.afterChangeFunction) this.props.afterChangeFunction(dataSource);
	};


	handleConditionItemChange = (index,category,value) =>{
		let dataSource = getValueHash(this.state.dataSource);
		let conditions = getValueHash(dataSource.conditions);
		let currentConditions = conditions[index];
		if(!currentConditions){
			currentConditions = {value:value.value,from:value.fromValue,to:value.toValue,keyword:value.keywordValue,searchType:value.searchType};
			conditions[index] = currentConditions;
		}
		else{
			switch(category){
				case "from":
					currentConditions.from = value;
					conditions[index] = currentConditions;
					break;
				case "to":
					currentConditions.to = value;
					conditions[index] = currentConditions;
					break;
				case "fromto":
					currentConditions.from = value.fromValue;
					currentConditions.to = value.toValue;
					conditions[index] = currentConditions;
					break;
				case "keyword":
					currentConditions.keyword = value;
					conditions[index] = currentConditions;
					break;
				case "searchType":
					if(value==="1"){
						currentConditions.keyword = null;
					}
					else{
						currentConditions.from = null;
						currentConditions.to = null;
					}
					currentConditions.searchType = value;
					conditions[index] = currentConditions;
					break;
				default:
					if(!value.value){
						conditions.splice(index,conditions.length-index);
					}
					else{
						currentConditions = {value:value.value,from:value.fromValue,to:value.toValue,keyword:value.keywordValue,searchType:value.searchType};
						conditions[index] = currentConditions;
					}
					break;
			}
		}

		dataSource.conditions = conditions;

		if(this.props.afterChangeFunction) this.props.afterChangeFunction(dataSource);
	};

	handleOutputItemChange =(event)=>{


		let dataSource = getValueHash(this.state.dataSource);
		let outputs = getValueArray(dataSource.outputs);

		const index = outputs.indexOf(event.target.value);
		if(index >= 0){
			outputs.splice(index,1);
		}
		else{
			outputs.push(event.target.value);
		}

		dataSource.outputs = outputs;
		if(this.props.afterChangeFunction) this.props.afterChangeFunction(dataSource);
	};

	handleAllOutputItemChange=(event)=>{
		const outputItemSource = this.props.outputItemSource;
		let dataSource = getValueHash(this.state.dataSource);
		let outputs = getValueArray(dataSource.outputs);

		const isAllChecked = (outputItemSource.length === outputs.length);

		if(isAllChecked){
			outputs = [];
		}
		else{
			outputs = outputItemSource.map((values)=>{return values.value});
		}

		dataSource.outputs = outputs;
		if(this.props.afterChangeFunction) this.props.afterChangeFunction(dataSource);

	};

	handleOutputOptionsChange = (event)=>{
		let dataSource = getValueHash(this.state.dataSource);
		dataSource[event.target.value] = !dataSource[event.target.value];
		if(this.props.afterChangeFunction) this.props.afterChangeFunction(dataSource);
	};

	render () {
		const { classes,aggregateSource,conditionSource,outputItemSource} = this.props;
		const { dataSource, dateType, selectedDateFrom,selectedDateTo} = this.state;

		const aggregateDataSource = ("aggregates" in dataSource) ? dataSource.aggregates : [];
		const conditionDataSource = ("conditions" in dataSource) ? dataSource.conditions : [];
		const outputSource = ("outputs" in dataSource) ? dataSource.outputs : [];

		let aggregateItems = [];
		for(let i=0; i<5; i++){
			let aggregateValue = null;
			let orderValue = 'ASC';
			if(aggregateDataSource.length > i){
				aggregateValue = aggregateDataSource[i].value;
				orderValue = aggregateDataSource[i].order;
			}
			const disabled = (aggregateDataSource.length < i);

			aggregateItems.push(
				<Aggregates
					aggregateSource={aggregateSource}
					dataIndex={i}
					aggregateValue={aggregateValue}
					orderValue={orderValue}
					afterChangeFunction={this.handleAggregateItemChange}
					key={i}
					disabled={disabled}
				/>
			);
		}

		let conditionItem = [];
		for(let i=0; i<5; i++){
			let conditionValue = null;
			let fromValue = null;
			let toValue = null;
			let keywordValue = null;
			let searchType = "2";


			if(conditionDataSource.length > i){
				conditionValue = conditionDataSource[i].value;
				if("from" in conditionDataSource[i]) fromValue = conditionDataSource[i].from;
				if("to" in conditionDataSource[i]) toValue = conditionDataSource[i].to;
				if("keyword" in conditionDataSource[i]) keywordValue = conditionDataSource[i].keyword;
				if("searchType" in conditionDataSource[i]) searchType = conditionDataSource[i].searchType;
			}
			const disabled = (conditionDataSource.length < i);
			conditionItem.push(
				<Conditions
					conditionSource={conditionSource}
					conditionValue={conditionValue}
					fromValue={fromValue}
					toValue={toValue}
					keywordValue={keywordValue}
					searchType={searchType}
					afterChangeFunction={this.handleConditionItemChange}
					dataIndex={i}
					key={i}
					disabled={disabled}
				/>
			);
		}

		let outputItem = [];
		outputItemSource.forEach((item,index)=>{
			const checked = (outputSource.indexOf(item.value) >= 0);
			outputItem.push(
				<FormControlLabel
					control={
						<Checkbox
							checked={checked}
							value={item.value}
							color="primary"
							name={item.value}
							onChange={this.handleOutputItemChange}
						/>
					}
					label={item.label}
					key={index}
				/>
			);
		});


		const isAllCheckIndeterminate = (outputSource.length > 0) && (outputItemSource.length !==outputSource.length);
		const isAllChecked = (outputItemSource.length === outputSource.length);

		const outputIsLastYear = ("outputIsLastYear" in dataSource) ? dataSource.outputIsLastYear : false;
		const outputSlipCount = ("outputSlipCount" in dataSource) ? dataSource.outputSlipCount : false;
		const outputDetailCount = ("outputDetailCount" in dataSource) ? dataSource.outputDetailCount : false;



		return ([
			<ExpansionPanel defaultExpanded key={"Aggregates"}>
				<ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} className={classes.summary}>
					<div className={classes.summaryColumnLeft}>
						<Typography className={classes.heading}>集計項目</Typography>
					</div>
					<div className={classes.summaryColumnRight}>
						<Typography className={classes.secondaryHeading}>集計を行う条件を最大5つまで設定します</Typography>
					</div>
				</ExpansionPanelSummary>
				<ExpansionPanelDetails className={classes.details}>
					{aggregateItems}
				</ExpansionPanelDetails>
			</ExpansionPanel>,
			<ExpansionPanel defaultExpanded key={"Conditions"}>
				<ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} className={classes.summary}>
					<div className={classes.summaryColumnLeft}>
						<Typography className={classes.heading}>抽出条件</Typography>
					</div>
					<div className={classes.summaryColumnRight}>
						<Typography className={classes.secondaryHeading}>集計対象とするデータの範囲を設定します</Typography>
					</div>
				</ExpansionPanelSummary>
				<ExpansionPanelDetails className={classes.details}>
					<FormGroup className={classes.root} row>
						<RadioGroup
							aria-label="gender"
							name="gender2"
							value={dateType}
							onChange={this.handleDateTypeChange}
							row
						>
							<FormControlLabel
								value="0"
								control={<Radio />}
								label="出荷日"

							/>
							<FormControlLabel
								value="1"
								control={<Radio />}
								label="納品日"
							/>
							<FormControlLabel
								value="2"
								control={<Radio />}
								label="伝票日付"

							/>
							<FormControlLabel
								value="3"
								control={<Radio />}
								label="取込日"
							/>
						</RadioGroup>
						<DatePicker
							keyboard
							label="開始"
							minDateMessage={"7年前までの日付を入力"}
							maxDateMessage={"10日後までの日付を入力"}
							minDate={new moment().add(-7, 'years')}
							maxDate={new moment().add(10, 'days')}
							value={selectedDateFrom}
							onChange={this.handleDateFromChange}
							onInputChange={this.handleDateFromInputChange}
							format="YYYY/MM/DD"
							className={classes.datePicker}
							invalidDateMessage="日付が正しくありません"
							cancelLabel={"キャンセル"}
						/>
						<div className={classes.fromTo}>-</div>
						<DatePicker
							keyboard
							label="終了"
							minDateMessage={"7年前までの日付を入力"}
							maxDateMessage={"10日後までの日付を入力"}
							minDate={new moment().add(-7, 'years')}
							maxDate={new moment().add(10, 'days')}
							value={selectedDateTo}
							onChange={this.handleDateToChange}
							onInputChange={this.handleDateToInputChange}
							className={classes.datePicker}
							format="YYYY/MM/DD"
							invalidDateMessage="日付が正しくありません"
							cancelLabel={"キャンセル"}
						/>
					</FormGroup>
					{conditionItem}
				</ExpansionPanelDetails>
			</ExpansionPanel>,
			<ExpansionPanel defaultExpanded key={"Outputs"}>
				<ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} className={classes.summary}>
					<div className={classes.summaryColumnLeft}>
						<Typography className={classes.heading}>出力項目</Typography>
					</div>
					<div className={classes.summaryColumnRight}>
						<Typography className={classes.secondaryHeading}>出力する項目を設定します</Typography>
					</div>
				</ExpansionPanelSummary>
				<ExpansionPanelDetails className={classes.details}>
					<FormControlLabel
						control={
							<Checkbox
								checked={isAllChecked}
								value="checkedAll"
								name="allChecked"
								indeterminate={isAllCheckIndeterminate}
								onChange={this.handleAllOutputItemChange}
							/>
						}
						label="全てチェック"

					/>
					<Divider />
					{outputItem}
				</ExpansionPanelDetails>

			</ExpansionPanel>,
			<ExpansionPanel defaultExpanded key={"Options"}>
				<ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} className={classes.summary}>
					<div className={classes.summaryColumnLeft}>
						<Typography className={classes.heading}>出力オプション</Typography>
					</div>
					<div className={classes.summaryColumnRight}>
						<Typography className={classes.secondaryHeading}>出力時のオプションを設定します</Typography>
					</div>
				</ExpansionPanelSummary>
				<ExpansionPanelDetails className={classes.details}>
					<FormControlLabel
						control={
							<Checkbox
								checked={outputSlipCount}
								value="outputSlipCount"
								name="outputSlipCount"
								onChange={this.handleOutputOptionsChange}
							/>
						}
						label="伝票枚数を出力する"
					/>
					<FormControlLabel
						control={
							<Checkbox
								checked={outputDetailCount}
								value="outputDetailCount"
								name="outputDetailCount"
								onChange={this.handleOutputOptionsChange}
							/>
						}
						label="明細件数を出力する"
					/>
					<FormControlLabel
						control={
							<Checkbox
								checked={outputIsLastYear}
								value="outputIsLastYear"
								name="outputIsLastYear"
								onChange={this.handleOutputOptionsChange}
							/>
						}
						label="昨年分を出力する"
					/>
				</ExpansionPanelDetails>
			</ExpansionPanel>


		]);
	}
}
innerForm.propTypes = {
	afterChangeFunction : PropTypes.func,
	dataSource: PropTypes.object,
	aggregateSource : PropTypes.array,
	conditionSource : PropTypes.array,
	outputItemSource : PropTypes.array,
};
innerForm.defaultProps = {
	dataSource: {},
	aggregateSource : [],
	conditionSource : [],
	outputItemSource : [],
};
export default withStyles(styles)(innerForm);



// WEBPACK FOOTER //
// ./src/routes/statistics/components/inner-form.js